export default __webpack_public_path__ + "static/media/Bowtie.da557ed3.jpg";